"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ListItemSecondaryAction = _interopRequireDefault(require("@mui/material/ListItemSecondaryAction"));
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _IconButton2 = require("../../IconButton/IconButton.types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ListItemIconButton = function ListItemIconButton(_ref) {
  var ariaLabel = _ref.ariaLabel,
    disabled = _ref.disabled,
    Icon = _ref.icon,
    onClick = _ref.onClick,
    variant = _ref.variant;
  function handleClick(e) {
    e.stopPropagation();
    onClick();
  }
  return /*#__PURE__*/_react["default"].createElement(_ListItemSecondaryAction["default"], null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": ariaLabel,
    disabled: disabled,
    onClick: handleClick,
    variant: variant,
    icon: Icon
  }));
};
ListItemIconButton.propTypes = process.env.NODE_ENV !== "production" ? {
  icon: _propTypes["default"].elementType.isRequired,
  ariaLabel: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  variant: _IconButton2.Variant
} : {};
var _default = exports["default"] = ListItemIconButton;